import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';

import { DiscountThemeService } from '@cakeiteasy/web-ui';
import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';

@Component({
  standalone: true,
  selector: 'product-price',
  imports: [CommonModule, NgCakeItEasyUtilsModule],
  styleUrls: ['./product-price.component.scss'],
  template: `
    @if (discount) {
      <div class="d-flex flex-wrap justify-content-center align-items-center" [class.discount-wrapper-xs]="smallSize">
        <span class="text-muted-warm text-cross-out">{{ price }}&nbsp;</span>
        <span class="ms-1" [class.text-discount]="!discountTheme.color()" [style.color]="discountTheme.color()">
          {{ price | tryToDiscountPrice: discount : currency }}
        </span>
        @if (perUnitText) {
          <span class="font-sm">&nbsp;{{ perUnitText }}</span>
        }
      </div>
    } @else {
      <span>{{ price | currencyFormat: currency }}</span>
      @if (perUnitText) {
        <span class="font-sm">&nbsp;{{ perUnitText }}</span>
      }
    }
  `,
})
export class ProductPriceComponent {
  @Input() price: number;
  @Input() currency: string;
  @Input() discount?: number;
  @Input() perUnitText?: string;
  @Input() smallSize = false;

  protected discountTheme = inject(DiscountThemeService);
}
